import { useCallback, useRef } from 'react';

// TODO switch to useEvent when React lib ready, read more at https://dev.to/romaintrotard/useevent-the-new-upcoming-hook-3482
export const useHandler = <F extends (...args: any[]) => unknown>(f: F) => {
  const ref = useRef(f);
  ref.current = f;
  return useCallback((...args: unknown[]) => ref.current(...(args as [])), []) as unknown as F;
};
